import moment from 'moment';
export function getCyclabilityZonesPeriods(zones) {
  const countByDate = {};
  zones.forEach(({
    id,
    stats
  }) => {
    stats.forEach(({
      dateAsKey: key
    }) => {
      if (!countByDate[key]) countByDate[key] = [id];else countByDate[key].push(id);
    });
  });
  const dateKeys = [];
  Object.keys(countByDate).forEach(key => {
    countByDate[key] = [...new Set(countByDate[key])];
    if (countByDate[key].length === zones.length) {
      dateKeys.push(key);
    }
  });
  dateKeys.sort((a, b) => a.localeCompare(b));
  return dateKeys.map(key => ({
    key,
    date: moment(key)
  }));
}